//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AppProduct from './Product.vue'
import TransitionToggle from '../transitions/Toggle.vue'
import { mapGetters, mapMutations } from 'vuex'
export default {
  name: "AppProducts",
  components: {
    AppProduct,
    TransitionToggle
  },
  data() {
    return {
      media: window.matchMedia('(min-width: 768px)'),
      top: '0px'
    }
  },
  computed: {
    ...mapGetters(['products', 'max', 'size']),
    disableRemove() {
      return this.size <= 2;
    },
    disableAdd() {
      return this.size >= this.max;
    },
  },
  methods: {
    ...mapMutations(['addComparison', 'removeComparison']),
    setTop() {
			let header = document.querySelector('.flow-header__content');
			let headerHeight = header ? header.offsetHeight : 0;
			// The header pins with a negative top offset so the utility bar scrolls away
			// (_flowHeader.js setHeaderOffset); only the remaining height stays on screen,
			// so stick directly below that instead of the full header height.
			let flowHeader = document.querySelector('.flow-header');
			let hiddenOffset = flowHeader ? Math.abs(parseFloat(getComputedStyle(flowHeader).top) || 0) : 0;
			this.top = `top: ${headerHeight - hiddenOffset}px`;
    }
  },
  mounted() {
    setTimeout(this.setTop, 500);
    window.addEventListener('resize', this.setTop);
  }
}
